import { formatDate, DATE_FORMATS } from '@frontend/mwm-ui'

import type { ICellRendererParams } from 'ag-grid-enterprise'
import type { ReactElement } from 'react'

import { MILLISECONDS_IN_NANO } from '~/const'

const DateTimeCellRenderer = ({ context, value }: ICellRendererParams<unknown, number>): ReactElement => {
  return (
    <span className="text">
      {value
        ? formatDate(value / MILLISECONDS_IN_NANO, DATE_FORMATS.DEFAULT_WITH_HOURS)
        : context.dateTimeCellRendererFallbackMessage ?? ''}
    </span>
  )
}

export default DateTimeCellRenderer
